import React, { useEffect, useState } from "react";
import Styles from "./MyProfilesList.module.scss";
import PlusIcon from "../../assets/icons/plus.svg";
import { useAppDispatch } from "../../redux/store";
import { useSelector } from "react-redux";
import preloader from "../../assets/img/load.gif";
import { CardListPropsType } from "./types";
import {
  fetchAddProfile,
  fetchMyProfiles,
  fetchProfileInfoMenu,
} from "../../redux/profile/profileInfo/asyncActions";
import { getProfileInfoMenu } from "../../redux/profile/profileInfo/selectors";
import { userDataSelector, partnerIdSelector } from "../../redux/user/selectors";
import { MyProfileItem } from "../MyProfilesItem/MyProfiles";
import { Modal } from "../Modal";
import { ProfileAdultForm } from "../ProfileAdultForm";
import { ProfileKidForm } from "../ProfileKidForm";
import { Button } from "../Button";
import { IMyprofile } from "../../redux/profile/profileInfo/types";
import { ValuesType as AdultValuesType } from "../ProfileAdultForm/type";
import { ValuesType as KidValuesType } from "../ProfileKidForm/type";
import { useLocation, useNavigate } from "react-router-dom";
import { setTempProfileData } from "../../redux/profile/tempProfiles/slice";
import { formatPhone } from "../../utils/form/phoneFormat";
import { useLookUpUsers } from "../../hooks/useLookUpUsers";
import { EmptyProfileScreen } from "../EmptyProfileScreen";
import { formatDateToISOWithTime, formatDateToISO } from "../../helpers/dateFormatter";

export const MyProfilesList: React.FC<CardListPropsType> = ({
  onPage = "profile",
  selectFunc,
  filterType,
}) => {
  const { myProfiles, isLoading, profile } = useSelector(getProfileInfoMenu);
  const userData = useSelector(userDataSelector);
  const userPartnerId = useSelector(partnerIdSelector);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { getBitrixUser, registerBitrixUser } = useLookUpUsers();
  const [isOpenModal, setIsOpenModal] = React.useState<boolean>(false);
  const [clicked, setIsClicked] = React.useState<boolean>(false);
  const [isAdult, setIsAdult] = useState(true);
  const [errorStatus, setErrorStatus] = React.useState<boolean>(false);

  const locationState = location.state as { 
    profileId?: string; 
    profileType?: string; 
    profileNumber?: number;
    returnPath?: string;
  } | null;
  const profileId = locationState?.profileId;
  const returnPath = locationState?.returnPath;

  let selectedItem: any = null;

  useEffect(() => {
    dispatch(fetchMyProfiles());
    if (onPage === "payment" || onPage === "profile") {
      dispatch(fetchProfileInfoMenu());
    }
  }, [onPage, dispatch]);

  const handleAddClick = () => {
    setIsOpenModal(true);
  };

  const addSelectStyles = React.useCallback((e: any) => {
    if (onPage === "payment") {
      const target = e.target.closest("[data-type]");

      if (target) {
        if (selectedItem) {
          selectedItem.style.boxShadow = "";
        }

        selectedItem = target;
        selectedItem.style.boxShadow = "2px 2px 15px #00CC66";
      }
    }
  }, []);

  const formatDateToDDMMYYYY = (dateString: string | null | undefined): string => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    } catch (error) {
      return dateString;
    }
  };

  const handleSelectItem = async (profileData: IMyprofile) => {
    if (onPage === "payment") {
      if (selectFunc) {
        selectFunc(profileData);
      }
      return;
    }
    
    if (profileId && onPage === "profile") {
      const birthDateFormatted = formatDateToDDMMYYYY(profileData.birth_date || profileData.birthday);
      const phoneFormatted = profileData.phone ? formatPhone(profileData.phone) : "";
      
      let bitrixPartnerId: string | number | null = null;
      try {
        const profileType = profileData.is_adult ? "adult" : "child";
        if (profileType === "adult" && phoneFormatted) {
          bitrixPartnerId = await getBitrixUser(phoneFormatted, null, null, null, true);
        } else if (profileType === "child" && profileData.partner_id && birthDateFormatted) {
          const birthDateISO = profileData.birth_date || profileData.birthday;
          bitrixPartnerId = await getBitrixUser(null, profileData.partner_id, birthDateISO || null, profileData.name || null, true);
        }
      } catch (error) {
      }
      
      const tempProfileData = {
        name: profileData.name || "",
        phone: phoneFormatted,
        email: "",
        birthDate: birthDateFormatted,
        message: "",
      };

      dispatch(setTempProfileData({
        profileId,
        profileData: tempProfileData,
      }));

      if (returnPath) {
        navigate(returnPath);
      } else {
        navigate(-1);
      }
      return;
    }
    
    if (onPage === "profile" && !profileId) {
      return;
    }
    
    if (selectFunc) {
      selectFunc(profileData);
    }
  };

  const handleAdultClick = () => {
    setIsAdult(true);
    setIsClicked(false);
  };

  const handleKidClick = () => {
    setIsAdult(false);
    setIsClicked(true);
  };

  return (
      <>
        <div className={Styles.wrapper}>
          {onPage === "profile" ? <p className={Styles.subTitile}>Мои Профили</p> : null}
          {isLoading ? (
              <div className={Styles.preloader}>
                <img className={Styles.preloader_img} src={preloader} alt="preloader" />
              </div>
          ) : (
              <div className={Styles.item} onClick={addSelectStyles}>
                {(() => {
                  const mainProfile = userData || (profile && profile.length > 0 ? profile[0] : null);
                  
                  const mainProfileAsMyProfile: IMyprofile | null = mainProfile ? {
                    id: mainProfile.id,
                    name: mainProfile.name || "",
                    is_adult: true,
                    phone: mainProfile.phone || null,
                    birth_date: null,
                    user_id: mainProfile.id,
                    created_at: (mainProfile as any).created_at || new Date().toISOString(),
                    updated_at: (mainProfile as any).updated_at || new Date().toISOString(),
                    deleted_at: null,
                    partner_id: (mainProfile as any).partner_id || null,
                    type: "adult",
                    birthday: null,
                    deleted: 0,
                    is_self: 1,
                    phone_1c_format_not_needed: null,
                    unique: null,
                  } : null;

                  let allProfiles = [...myProfiles];
                  
                  if (mainProfileAsMyProfile) {
                    const shouldIncludeMainProfile = !filterType || mainProfileAsMyProfile.type === filterType;
                    const isMainProfileInList = myProfiles.some(p => p.id === mainProfileAsMyProfile.id);
                    
                    if (shouldIncludeMainProfile && !isMainProfileInList) {
                      allProfiles = [mainProfileAsMyProfile, ...myProfiles];
                    }
                  }

                  const filteredProfiles = filterType 
                    ? allProfiles.filter((item) => item.type === filterType)
                    : allProfiles;
                  
                  if (filteredProfiles.length === 0) {
                    return (
                      <EmptyProfileScreen
                        isSelectionMode={onPage === "payment"}
                        onCreateProfile={handleAddClick}
                      />
                    );
                  }
                  
                  return filteredProfiles.map((item) => (
                          <MyProfileItem
                              data={item}
                              key={item.id}
                              dataType="profileItem"
                              onPage={onPage}
                              selectFunc={onPage === "payment" || (onPage === "profile" && profileId) ? handleSelectItem : undefined}
                          />
                  ));
                })()}
                {
                  onPage === "profile" ? (
                      <div onClick={handleAddClick} className={`${Styles.item_plusItem}`}>
                        <img src={PlusIcon} />
                        <span className={Styles.title}>Добавить еще профиль</span>
                      </div>
                  ) : null
                }
              </div>
          )}
          {isOpenModal ? (
              <Modal
                  title="Новый профиль"
                  isOpen={isOpenModal}
                  setIsOpen={setIsOpenModal}
                  subTitle=""
              >
                <div className={Styles.switcher}>
                  <button 
                    className={`${Styles.switcher__button} ${!clicked ? Styles.switcher__button_active : ''}`}
                    onClick={handleAdultClick}
                  >
                    Взрослый
                  </button>
                  <button 
                    className={`${Styles.switcher__button} ${clicked ? Styles.switcher__button_active : ''}`}
                    onClick={handleKidClick}
                  >
                    Детский
                  </button>
                </div>
                <div className={Styles.textModal}>Заполните данные нового профиля</div>
                {isAdult ? (
                    <ProfileAdultForm
                        page={"profile"}
                        error={errorStatus}
                        close={async (values: AdultValuesType) => {
                          try {
                            setErrorStatus(false);
                            
                            const phoneTemp = values.phone ? `+${values.phone.replace(/\D/g, "")}` : "";
                            
                            let bitrixPartnerId: string | number | null = null;
                            try {
                              if (phoneTemp && values.name) {
                                bitrixPartnerId = await getBitrixUser(phoneTemp, null, null, null, true);
                                
                                if (!bitrixPartnerId) {
                                  bitrixPartnerId = await registerBitrixUser(
                                    "adult",
                                    phoneTemp,
                                    values.email || "",
                                    values.name,
                                    null,
                                    null,
                                    true
                                  );
                                }
                              }
                            } catch (bitrixError) {
                            }
                            
                            const profileData: any = {
                              name: values.name,
                              is_adult: true,
                              phone: phoneTemp,
                            };
                            
                            if (bitrixPartnerId) {
                              profileData.partner_id = String(bitrixPartnerId);
                            }
                            
                            const status = await dispatch(
                                fetchAddProfile(profileData)
                            );
                            if (status.payload === 201) {
                              setErrorStatus(false);
                              await dispatch(fetchMyProfiles());
                              setIsOpenModal(false);
                            } else {
                              setErrorStatus(true);
                            }
                          } catch (error) {
                            setErrorStatus(true);
                          }
                        }}
                    />
                ) : (
                    <ProfileKidForm
                        page={"profile"}
                        close={async (values: KidValuesType) => {
                          try {
                            const formattedDate = values.birthday ? formatDateToISO(values.birthday) : "";
                            
                            let bitrixPartnerId: string | number | null = null;
                            try {
                              if (formattedDate && values.name && userPartnerId) {
                                const birthDateISO = formatDateToISOWithTime(values.birthday);
                                
                                bitrixPartnerId = await getBitrixUser(
                                  null,
                                  userPartnerId.toString(),
                                  birthDateISO,
                                  values.name,
                                  true
                                );
                                
                                if (!bitrixPartnerId) {
                                  bitrixPartnerId = await registerBitrixUser(
                                    "child",
                                    null,
                                    null,
                                    values.name,
                                    userPartnerId.toString(),
                                    birthDateISO,
                                    true
                                  );
                                }
                              }
                            } catch (bitrixError) {
                            }
                            
                            const profileData: any = {
                              name: values.name,
                              is_adult: false,
                              birth_date: formattedDate,
                            };
                            
                            if (bitrixPartnerId) {
                              profileData.partner_id = String(bitrixPartnerId);
                            }
                            
                            const status = await dispatch(
                                fetchAddProfile(profileData)
                            );
                            if (status.payload === 201) {
                              await dispatch(fetchMyProfiles());
                              setIsOpenModal(false);
                            }
                          } catch (error) {
                          }
                        }}
                    />
                )}
              </Modal>
          ) : null}
        </div>
      </>

  );
};
